import { Pagination } from "react-bootstrap";
import "./CustomPagination.scss";

const CustomPagination = ({
  page,
  totalPages,
  handleNextPage,
  handlePrevPage,
  handleLastPage,
  handleFirstPage,
}) => {
  const showNextPage = () => page < totalPages;
  const showPrevPage = () => page > 1;
  const showLastPage = () => page !== totalPages && totalPages > 1;
  const showFirstPage = () => page !== 1;

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Pagination>
        {showFirstPage() && <Pagination.First onClick={handleFirstPage} />}
        {showPrevPage() && <Pagination.Prev onClick={handlePrevPage} />}
        {showPrevPage() && <Pagination.Ellipsis disabled />}

        <Pagination.Item active>{page}</Pagination.Item>

        {showNextPage() && <Pagination.Ellipsis disabled />}
        {showNextPage() && <Pagination.Next onClick={handleNextPage} />}
        {showLastPage() && <Pagination.Last onClick={handleLastPage} />}
      </Pagination>
    </div>
  );
};

export default CustomPagination;
